//@flow
import { SubmissionError } from "redux-form"

type MutationError = {
  graphQLErrors: {
    location: string,
    state?: Map<string, Array<string>>
  }
}

type ErrorList = { [string]: string }

type errorTransform = (errors: ?ErrorList) => ?ErrorList

const getKey = (k: string): string => (k === "" ? "_error" : k)

const handleMutationError = (
  mutationError: string,
  transform: ?errorTransform
) => {
  const error: MutationError = JSON.parse(JSON.stringify(mutationError))
  const { graphQLErrors } = error
  if (graphQLErrors && graphQLErrors[0].state) {
    const state = graphQLErrors[0].state
    if (!state) {
      return
    }
    const errors: ErrorList = Object.keys(state).reduce(
      (results, k) => ({ [getKey(k)]: state[k][0], ...results }),
      {}
    )
    throw new SubmissionError(transform ? transform(errors) : errors)
  }
}

export default handleMutationError



// WEBPACK FOOTER //
// ./src/API/handleMutationError.js